<template>
  <van-grid :column-num="3" icon-size="40" :border="false">
    <van-grid-item
      v-for="(item, index) in navs"
      :key="index"
      :icon="item.picUrl"
      :text="item.text"
      :url="item.linkUrl"
    />
  </van-grid>
</template>

<script>
  import { mainNavItems } from './config';

  export default {
    name: 'HomeMainNav',
    data() {
      return {
        navs: mainNavItems,
      };
    },
  };
</script>

<style lang="scss" scoped>
.van-grid {
  padding-top: 15px;

  .van-grid-item {
    ::v-deep .van-grid-item__content {
      padding-top: 0;
      padding-bottom: 15px;
      background-color: transparent;
    }
  }
}
</style>
